import {Component} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'wm-account-activated',
  templateUrl: './account-activated.component.html',
  styleUrls: ['./account-activated.component.less'],
})
export class AccountActivatedComponent {

  constructor(private router: Router) { /* nothing really */ }

  goToSignIn(){
    this.router.navigate(["/login"]);
  }
}
